// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2QC2v","header":"Messages_header__36jPc"};